import { Observable, startWith } from 'rxjs';

/**
 * Watch for attributes change on element
 *
 * @param element - element to watch
 * @param emitFirst - make initial emit with element
 */
export function onAttributeChange$(
  element: HTMLElement,
  emitFirst = false,
): Observable<HTMLElement> {
  const change = new Observable<HTMLElement>(observer => {
    const mutationObserver = new MutationObserver(() => {
      observer.next(element);
    });
    mutationObserver.observe(element, {
      attributes: true,
    });

    return () => mutationObserver.disconnect();
  });
  return emitFirst ? change.pipe(startWith(element)) : change;
}
